import { render, staticRenderFns } from "./RenovationMAndEProject.vue?vue&type=template&id=dc5bb45a&"
import script from "./RenovationMAndEProject.vue?vue&type=script&lang=js&"
export * from "./RenovationMAndEProject.vue?vue&type=script&lang=js&"
import style0 from "./RenovationMAndEProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports